import Sidebar from './index.vue';
import SidebarContent from './SidebarContent.vue';
import SidebarGroup from './SidebarGroup.vue';
import SidebarGroupContent from './SidebarGroupContent.vue';
import SidebarGroupLabel from './SidebarGroupLabel.vue';
import SidebarHeader from './SidebarHeader.vue';
import SidebarMenu from './SidebarMenu.vue';
import SidebarMenuButton from './SidebarMenuButton.vue';
import SidebarMenuItem from './SidebarMenuItem.vue';
import SidebarPopover from './SidebarPopover.vue';

Sidebar.Content = SidebarContent;
Sidebar.Header = SidebarHeader;
Sidebar.Group = SidebarGroup;
Sidebar.GroupContent = SidebarGroupContent;
Sidebar.GroupLabel = SidebarGroupLabel;
Sidebar.Menu = SidebarMenu;
Sidebar.MenuItem = SidebarMenuItem;
Sidebar.MenuButton = SidebarMenuButton;
Sidebar.Popover = SidebarPopover;

export default Sidebar;
